import { Routes } from '@angular/router'
import { Guards } from './core/security/guards.util'
import { LoginComponent } from './features/account/login/login.component'
import { LogoutComponent } from './features/account/logout/logout.component'
import { MfaComponent } from './features/account/mfa/mfa.component'
import { HomeComponent } from './features/home/home.component'
import { EditGroupComponent } from './features/maintenance/group-management/edit/edit-group.component'
import { ListGroupComponent } from './features/maintenance/group-management/list/list-group.component'
import { EditUserComponent } from './features/maintenance/user-management/edit/edit-user.component'
import { ListUserComponent } from './features/maintenance/user-management/list/list-user.component'
import { LoginMessageComponent } from './features/maintenance/hq-management/login-message/login-message.component'
import { ListApplicationComponent } from './features/maintenance/application-management/list/list-application.component'
import { EditApplicationComponent } from './features/maintenance/application-management/edit/edit-application/edit-application.component'
import { PasswordResetComponent } from './features/account/password-reset/password-reset.component'
import { DCSToggleComponent } from './features/maintenance/hq-management/dcs-toggle/dcs-toggle.component'
import { ActiveSessionViewComponent } from './features/management/active-session-view/active-session-view.component'
import { EditPageComponent } from './features/maintenance/page-management/edit-page/edit-page.component'
import { CookiePolicyComponent } from "./features/policy/cookie-policy/cookie-policy.component"
import { PrivacyPolicyComponent } from "./features/policy/privacy-policy/privacy-policy.component"
import { LinksPageComponent } from './features/static-page/links-page.component'
import { ManageAccountComponent } from './features/account/manage-mfa/manage-account.component'
import { EnrollAuthAppComponent } from './features/account/enroll-auth-app/enroll-auth-app.component'
import { EnrollSmsMfaComponent } from "./features/account/enroll-sms-mfa/enroll-sms-mfa.component"

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [
            Guards.notLoggedIn
        ],
    },
    {
        path: 'logout',
        component: LogoutComponent,
    },
    {
        path: 'mfa',
        component: MfaComponent,
        canActivate: [
            Guards.isLoggedInButNotVerified
        ]
    },
    {
        path: 'account',
        children: [
            {
                path: 'password-expired',
                component: PasswordResetComponent,
                canActivate: [
                    Guards.isLoggedInAndVerified,
                    Guards.passwordExpired
                ]
            },
            {
                path: 'change-password',
                component: PasswordResetComponent,
                canActivate: [
                    Guards.isLoggedInAndVerified,
                    Guards.passwordNotExpired,
                ]
            },
            {
                path: 'manage-account',
                component: ManageAccountComponent,
                canActivate: [
                    Guards.isLoggedInAndVerified,
                    Guards.passwordNotExpired,
                ],
            },
            {
                path: 'first-time-mfa',
                component: ManageAccountComponent,
                canActivate: [
                    Guards.hasDefaultMfa,
                ]
            },
            {
                path: 'enroll-app-mfa',
                component: EnrollAuthAppComponent,
                canActivate: [
                    Guards.passwordNotExpired
                ]
            },
            {
                path: 'enroll-sms-mfa',
                component: EnrollSmsMfaComponent,
                canActivate: [
                    Guards.passwordNotExpired
                ]
            },
        ]
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [
            Guards.isLoggedInAndVerified,
            Guards.passwordNotExpired,
        ]
    },
    {
        path: 'access-denied',
        redirectTo: '/home?accessDenied',
    },
    {
        path: 'disabled',
        redirectTo: '/home?disabled',
    },
    {
        path: 'administration',
        children: [
            {
                path: 'user',
                children: [
                    {
                        path: '',
                        component: ListUserComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroups('USER', 'DCSADMINISTRATOR')
                        ]
                    },
                    {
                        path: 'create',
                        component: EditUserComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroups('USER', 'DCSADMINISTRATOR')
                        ]
                    },
                    {
                        path: ':userId',
                        component: EditUserComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroups('USER', 'DCSADMINISTRATOR')
                        ]
                    },
                ]
            },
            {
                path: 'sub-user',
                children: [
                    {
                        path: '',
                        component: ListUserComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DEALERADMIN')
                        ]
                    },
                    {
                        path: 'create',
                        component: EditUserComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DEALERADMIN')
                        ]
                    },
                    {
                        path: ':userId',
                        component: EditUserComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DEALERADMIN')
                        ]
                    },
                ]
            },
            {
                path: 'group',
                children: [
                    {
                        path: '',
                        component: ListGroupComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },
                    {
                        path: 'create',
                        component: EditGroupComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },
                    {
                        path: ':groupId',
                        component: EditGroupComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },
                ]
            },
            {
                path: 'active-users',
                children: [
                    {
                        path: '',
                        component: ActiveSessionViewComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },
                ]
            },
            {
                path: 'hq',
                children: [
                    {
                        path: 'login-message',
                        component: LoginMessageComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },
                    {
                        path: 'dcs-toggle',
                        component: DCSToggleComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },

                ]
            },
            {
                path: 'application',
                children: [
                    {
                        path: '',
                        component: ListApplicationComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },
                    {
                        path: 'create',
                        component: EditApplicationComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ]
                    },
                    {
                        path: ':applicationId',
                        component: EditApplicationComponent,
                        canActivate: [
                            Guards.isLoggedInAndVerified,
                            Guards.passwordNotExpired,
                            Guards.hasGroup('DCSADMINISTRATOR')
                        ],
                    },
                    {
                        path: ':applicationId/page',
                        children: [
                            {
                                path: 'create',
                                component: EditPageComponent,
                                canActivate: [
                                    Guards.isLoggedInAndVerified,
                                    Guards.passwordNotExpired,
                                    Guards.hasGroup('DCSADMINISTRATOR')
                                ]
                            },
                            {
                                path: ':pageId',
                                component: EditPageComponent,
                                canActivate: [
                                    Guards.isLoggedInAndVerified,
                                    Guards.passwordNotExpired,
                                    Guards.hasGroup('DCSADMINISTRATOR')
                                ]
                            }
                        ]
                    }
                ]
            },
        ],
    },
    {
        path: 'policy',
        children: [
            {
                path: 'cookies',
                component: CookiePolicyComponent,
            },
            {
                path: 'privacy',
                component: PrivacyPolicyComponent,
            }
        ]
    },
    {
        path: '2w-links',
        component: LinksPageComponent,
        canActivate: [
            Guards.isLoggedInAndVerified,
            Guards.passwordNotExpired,
        ],
        data: {
            content: '2W'
        }
    },
    {
        path: '2w-lite',
        component: LinksPageComponent,
        canActivate: [
            Guards.isLoggedInAndVerified,
            Guards.passwordNotExpired,
        ],
        data: {
            content: '2W-Lite'
        }
    },
    {
        path: '4w-links',
        component: LinksPageComponent,
        canActivate: [
            Guards.isLoggedInAndVerified,
            Guards.passwordNotExpired,
        ],
        data: {
            content: '4W'
        }
    },
    {
        path: 'atv-links',
        component: LinksPageComponent,
        canActivate: [
            Guards.isLoggedInAndVerified,
            Guards.passwordNotExpired,
        ],
        data: {
            content: 'ATV'
        }
    },
    {
        path: 'marine-links',
        component: LinksPageComponent,
        canActivate: [
            Guards.isLoggedInAndVerified,
            Guards.passwordNotExpired,
        ],
        data: {
            content: 'Marine'
        }
    },

    // otherwise redirect to home
    { path: '**', redirectTo: 'home' }
]
